export default "__VITE_ASSET__CuyQPYcb__"